<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <ul
        class="nav nav-tabs bg-white border-0 rounded-0"
        id="myTab"
        role="tablist"
      >
        <li class="nav-item" role="presentation">
          <button
            class="nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100 active"
            id="edit-user-tab"
            data-bs-toggle="tab"
            data-bs-target="#edit-user-tab-pane"
            type="button"
            role="tab"
            aria-controls="edit-user-tab-pane"
            aria-selected="true"
          >
            Informations de l'utilisateur
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100"
            id="driver-fees-tab"
            data-bs-toggle="tab"
            data-bs-target="#driver-fees-tab-pane"
            type="button"
            role="tab"
            aria-controls="driver-fees-tab-pane"
            aria-selected="false"
          >
            Frais de livreur
          </button>
        </li>
        <li
          class="nav-item"
          role="presentation"
          v-if="auth.can('PERMISSION_USER')"
        >
          <button
            class="nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100"
            id="permission-tab"
            data-bs-toggle="tab"
            data-bs-target="#permission-tab-pane"
            type="button"
            role="tab"
            aria-controls="permission-tab-pane"
            aria-selected="false"
          >
            Permissions
          </button>
        </li>
      </ul>
      <div class="tab-content p-15 p-sm-20 p-md-25 p-lg-30" id="myTabContent">
        <div
          class="tab-pane fade show active"
          id="edit-user-tab-pane"
          role="tabpanel"
          tabindex="0"
        >
          <form @submit.prevent="handleSubmit">
            <div class="row">
              <!-- Profile Image -->
              <div class="col-md-12 mb-20">
                <label class="d-block text-black fw-semibold mb-10">
                  Photo de profil
                </label>
                <div class="d-flex align-items-center">
                  <img
                    v-if="imagepreview"
                    :src="imagepreview"
                    class="rounded-circle me-15"
                    style="width: 90px; height: 90px; object-fit: cover"
                  />
                  <img
                    v-else
                    :src="require('@/assets/images/NoImage.png')"
                    class="rounded-circle me-15"
                    style="width: 90px; height: 90px; object-fit: cover"
                  />
                  <div>
                    <input
                      ref="updateImgInput"
                      type="file"
                      accept="image/*"
                      class="d-none"
                      @change="logoSelected"
                    />
                    <button
                      type="button"
                      class="btn btn-primary me-2"
                      @click="() => updateImgInput?.click()"
                    >
                      Choisir la photo
                    </button>
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      @click="cancelImage"
                    >
                      Annuler
                    </button>
                  </div>
                </div>
              </div>

              <!-- Nom complet -->
              <div class="col-md-6 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Nom complet *</label
                >
                <input
                  v-model="userData.name"
                  type="text"
                  class="form-control shadow-none rounded-0"
                  placeholder="Nom complet"
                  required
                />
              </div>

              <!-- CIN -->
              <div class="col-md-6 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >CIN *</label
                >
                <input
                  v-model="userData.cin"
                  type="text"
                  class="form-control shadow-none rounded-0"
                  placeholder="CIN"
                  required
                />
              </div>

              <!-- CIN Pièces jointes -->
              <!-- <div class="col-md-12 mb-20">
            <label class="d-block text-black fw-semibold mb-10"
              >CIN (Pièces jointes) *</label
            >
            <input
              type="file"
              class="form-control shadow-none rounded-0"
              accept="image/*"
              multiple
              @change="fileSelected"
            />
            <div v-if="attachments.length" class="mt-2">
              <div
                v-for="(a, i) in attachments"
                :key="i"
                class="small text-muted"
              >
                {{ a.name }} ({{ (a.size / 1024 / 1024).toFixed(1) }} MB)
              </div>
            </div>
            <div
              v-if="urls.length"
              class="d-flex mt-2 align-items-start flex-wrap"
            >
              <img
                v-for="(url, i) in urls"
                :key="i"
                :src="url"
                class="me-2 mb-2"
                style="height: 120px; object-fit: cover"
              />
              <button
                type="button"
                class="btn btn-sm btn-danger"
                @click="removeFiles"
              >
                Supprimer
              </button>
            </div>
          </div> -->

              <!-- Téléphone -->
              <div class="col-md-6 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Numéro de téléphone *</label
                >
                <input
                  v-model="userData.phone"
                  type="text"
                  pattern="^(0[0-9]{9}|\+212[0-9]{9})$"
                  class="form-control shadow-none rounded-0"
                  placeholder="0XXXXXXXXX ou +212XXXXXXXXX"
                  required
                />
              </div>

              <!-- Email -->
              <div class="col-md-6 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Adresse électronique *</label
                >
                <input
                  v-model="userData.email"
                  type="email"
                  class="form-control shadow-none rounded-0"
                  placeholder="exemple@email.com"
                  required
                />
              </div>

              <!-- Password -->
              <div class="col-md-6 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Mot de passe *</label
                >
                <input
                  v-model="userData.password"
                  type="password"
                  class="form-control shadow-none rounded-0"
                  placeholder="Mot de passe"
                />
              </div>

              <!-- Confirm Password -->
              <div class="col-md-6 mb-20">
                <label class="d-block text-black fw-semibold mb-10">
                  Confirmation de mot de passe
                  <span v-if="userData.password">*</span>
                </label>
                <input
                  v-model="userData.c_password"
                  type="password"
                  class="form-control shadow-none rounded-0"
                  placeholder="Confirmer mot de passe"
                  :required="!!userData.password"
                />
              </div>

              <!-- Ville Utilisateur -->
              <div class="col-md-12 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Ville utilisateur *</label
                >
                <input
                  v-model="userData.city_user"
                  type="text"
                  class="form-control shadow-none rounded-0"
                  placeholder="Ville utilisateur"
                  required
                />
              </div>

              <!-- Ville -->
              <div class="col-md-12 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Ville *</label
                >
                <select
                  v-model="userData.city_id"
                  class="form-select shadow-none rounded-0"
                  required
                >
                  <option v-for="(c, i) in citiesList" :key="i" :value="c.id">
                    {{ c.name }}
                  </option>
                </select>
              </div>

              <!-- Adresse -->
              <div class="col-md-12 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Adresse *</label
                >
                <textarea
                  v-model="userData.adresse"
                  rows="2"
                  class="form-control shadow-none rounded-0"
                  placeholder="Adresse complète"
                  required
                ></textarea>
              </div>

              <!-- Bank, RIB, Agency, Fonction -->
              <div class="col-md-6 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Nom du banque *</label
                >
                <select
                  v-model="userData.id_bank"
                  class="form-select shadow-none rounded-0"
                  required
                >
                  <option v-for="(b, i) in bankList" :key="i" :value="b.id">
                    {{ b.name }}
                  </option>
                </select>
              </div>

              <div class="col-md-6 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Numéro du compte *</label
                >
                <input
                  v-model="userData.rib"
                  type="text"
                  inputmode="numeric"
                  pattern="[0-9]{24}"
                  class="form-control shadow-none rounded-0"
                  minlength="24"
                  maxlength="24"
                  placeholder="RIB"
                  required
                />
              </div>

              <div class="col-md-6 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Agence *</label
                >
                <select
                  v-model="userData.agency"
                  class="form-select shadow-none rounded-0"
                  required
                >
                  <option v-for="(a, i) in agencyList" :key="i" :value="a.id">
                    {{ a.name }}
                  </option>
                </select>
              </div>

              <div class="col-md-6 mb-20">
                <label class="d-block text-black fw-semibold mb-10"
                  >Fonction *</label
                >
                <select
                  v-model="userData.role_id"
                  class="form-select shadow-none rounded-0"
                  required
                >
                  <option
                    v-for="(f, i) in functionsList"
                    :key="i"
                    :value="f.id"
                  >
                    {{ f.name }}
                  </option>
                </select>
              </div>

              <!-- Zone / Fees only if Livreur -->
              <template v-if="userData?.role_id === 4">
                <div class="col-md-4 mb-20">
                  <label class="d-block text-black fw-semibold mb-10"
                    >Zone *</label
                  >
                  <select
                    v-model="userData.zone_liv_id"
                    class="form-select shadow-none rounded-0"
                  >
                    <option v-for="(z, i) in zoneList" :key="i" :value="z.id">
                      {{ z.name }}
                    </option>
                  </select>
                </div>

                <div class="col-md-4 mb-20">
                  <label class="d-block text-black fw-semibold mb-10"
                    >Frais de livraison *</label
                  >
                  <input
                    v-model="userData.livred_fees"
                    type="text"
                    class="form-control shadow-none rounded-0"
                    placeholder="Frais de livraison"
                  />
                </div>

                <div class="col-md-4 mb-20">
                  <label class="d-block text-black fw-semibold mb-10"
                    >Frais de refus *</label
                  >
                  <input
                    v-model="userData.refused_fees"
                    type="text"
                    class="form-control shadow-none rounded-0"
                    placeholder="Frais de refus"
                  />
                </div>

                <!-- Changement de statut -->
              <div class="col-md-6 mb-20">
                <label class="d-block text-black fw-semibold mb-10">
                  Peut changer le statut
                </label>
                <div class="d-flex align-items-center gap-3 mt-2">
                  <div
                    class="form-check form-check-inline"
                    v-for="opt in [{ label: 'Oui', value: '1' }, { label: 'Non', value: '0' }]"
                    :key="opt.value"
                  >
                    <input
                      class="form-check-input"
                      type="radio"
                      :id="`can_change_statut_${opt.value}`"
                      :value="opt.value"
                      v-model="userData.can_change_statut"
                    />
                    <label
                      class="form-check-label fw-medium"
                      :class="opt.value === '1' ? 'text-success' : 'text-danger'"
                      :for="`can_change_statut_${opt.value}`"
                    >
                      {{ opt.label }}
                    </label>
                  </div>
                </div>
              </div>
              </template>

              

              <!-- Submit -->
              <div
                class="col-md-12 d-flex align-items-center justify-content-between mt-20"
              >
                <button type="submit" class="btn btn-success px-4 py-2">
                  Enregistrer
                  <span
                    v-if="loading"
                    class="spinner-border spinner-border-sm ms-2"
                  ></span>
                </button>
                <router-link to="/users-list" class="btn btn-link text-danger">
                  Annuler
                </router-link>
              </div>
            </div>
          </form>
        </div>
        <div
          class="tab-pane fade"
          id="driver-fees-tab-pane"
          role="tabpanel"
          tabindex="0"
        >
          <form @submit.prevent="handleSubmit" v-if="citiesDriver.length != 0">
            <div class="row" v-for="citie in citiesDriver" :key="citie.id">
              <div class="col-12 col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label>
                    {{ "Frais de livraison ( " + citie.name + ")" }}</label
                  >
                  <input
                    class="form-control"
                    type="number"
                    min="0"
                    v-model="citie.delivered_fees"
                  />
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label label-for="refused_fees">{{
                    "Frais de refus ( " + citie.name + ")"
                  }}</label>
                  <input
                    class="form-control"
                    type="number"
                    min="0"
                    v-model="citie.refused_fees"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <button
                  v-if="auth.can('EDIT_USER')"
                  class="btn btn-primary px-4 py-2"
                  @click="editFeesDriver"
                >
                  Enregistrer
                </button>
              </div>
            </div>
          </form>

          <div class="row" v-else>
            <div class="col-md-12 d-flex align-items-center">
              <button
                :disabled="loadFees"
                v-if="auth.can('EDIT_USER')"
                class="btn btn-primary px-4 py-2"
                type="button"
                @click="handelAffectFees"
              >
                <template v-if="loadFees">
                  <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </template>
                Réaffecter les frais de livraison pour ce livreur
              </button>
            </div>
            <div class="col-md-12 d-flex align-items-center">
              <span class="align-middle ml-50">
                <center>Aucune donnée trouvée</center>
              </span>
            </div>
          </div>
        </div>
        <div
          v-if="auth.can('PERMISSION_USER')"
          class="tab-pane fade"
          id="permission-tab-pane"
          role="tabpanel"
          tabindex="0"
        >
          <div class="card shadow-sm">
            <!-- Header -->
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h5>Permissions d'utilisateur</h5>
              <button
                v-if="auth.can('PERMISSION_USER')"
                class="btn btn-primary"
                @click="AddPerms"
                :disabled="load"
              >
                Enregistrer
                <div v-if="load" class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </button>
            </div>

            <!-- Body -->
            <div
              class="card-body p-2"
              style="max-height: 450px; overflow-y: auto"
            >
              <div
                v-for="(group, index) in permissionsData"
                :key="index"
                class="card mb-2 border-0 shadow-sm"
              >
                <!-- Group Header -->
                <div
                  class="card-header d-flex justify-content-between align-items-center bg-light"
                  style="cursor: pointer"
                  @click="toggleGroup(index)"
                >
                  <div>
                    <strong>{{ group.code ?? group.name }}</strong>
                    <div class="text-muted small">
                      {{ group.description || "" }}
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <span class="badge bg-secondary me-2">
                      {{ group?.enabled?.length ?? 0 }}/{{
                        group?.permissions?.length ?? 0
                      }}
                    </span>
                    <div class="form-check form-switch">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="group.check"
                        @change="toggleAll(group)"
                      />
                    </div>
                  </div>
                </div>

                <!-- Group Permissions -->
                <div v-show="group.open" class="card-body p-2">
                  <div
                    v-for="(perm, i) in group.permissions"
                    :key="i"
                    class="d-flex justify-content-between align-items-center border-bottom py-2"
                  >
                    <div>
                      <small class="fw-bold">{{ perm.name }}</small>
                      <div class="text-muted small">
                        {{ perm.description || "" }}
                      </div>
                    </div>
                    <div class="form-check form-switch">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :checked="group.enabled.includes(perm.key)"
                        v-model="perm.check"
                        @change="togglePermission(group, perm.key)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import { reactive } from "vue";
import { defineComponent, onMounted, ref } from "vue";

export default defineComponent({
  name: "EditUser",
  components: {},
  props: {
    userId: {
      type: String,
      required: true,
    },
  },
  setup: (props) => {
    const auth = useAuthStore();

    const updateImgInput = ref<HTMLInputElement | null>(null);
    const imagepreview = ref<string | null>(null);
    const attachments = ref<File[]>([]);
    const urls = ref<string[]>([]);
    const loading = ref(false);

    const zoneList = ref<any[]>([]);
    const functionsList = ref<any[]>([]);
    const agencyList = ref<any[]>([]);
    const bankList = ref<any[]>([]);
    const citiesList = ref<any[]>([]);
    const { showToast } = useAppToast();
    const userData = reactive<Record<string, any>>({});

    const citiesDriver = ref<any[]>([]);
    const loadFees = ref(false);
    const load = ref(false);

    const permissionsData = ref<any[]>([]);

    onMounted(async () => {
      getUser();
      getPerms();

      try {
        const response = await api.get("/api/auth/citiesList");
        if (response && response.data) {
          citiesList.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching agencies:", error);
      }

      // zones
      try {
        const response = await api.get("/api/auth/ListZone");
        if (response && response.data) {
          zoneList.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching agencies:", error);
      }

      // zones
      try {
        const response = await api.get("/api/auth/agency");
        if (response && response.data) {
          agencyList.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching agencies:", error);
      }

      // FunctionsList
      try {
        const response = await api.get("/api/auth/list_role");
        if (response && response.data) {
          functionsList.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching agencies:", error);
      }

      // FunctionsList
      try {
        const response = await api.get("/api/auth/banks");
        if (response && response.data) {
          bankList.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching agencies:", error);
      }
    });

    const logoSelected = (e: Event) => {
      const file = (e.target as HTMLInputElement).files?.[0];
      if (file) {
        imagepreview.value = URL.createObjectURL(file);
      }
    };

    const cancelImage = () => {
      imagepreview.value = null;
      if (updateImgInput.value) updateImgInput.value.value = "";
    };

    const fileSelected = (e: Event) => {
      const files = Array.from((e.target as HTMLInputElement).files || []);
      attachments.value = files;
      urls.value = files.map((f) => URL.createObjectURL(f));
    };

    const removeFiles = () => {
      attachments.value = [];
      urls.value = [];
    };

    const handleSubmit = async () => {
      if (userData.password && userData.password !== userData.c_password) {
        showToast("Les mots de passe ne correspondent pas", "error");
        return;
      }
      loading.value = true;
      console.log(userData);
      const formData = new FormData();
      formData.append("name", userData.name);
      formData.append("cin", userData.cin);
      formData.append("phone", userData.phone);
      formData.append("email", userData.email);
      if (userData.password) {
        formData.append("password", userData.password);
        formData.append("c_password", userData.c_password);
      }
      formData.append("city_user", userData.city_user);
      formData.append("city_id", userData.city_id || "");
      formData.append("adresse", userData.adresse);
      formData.append("bank_id", userData.id_bank || "");
      formData.append("rib", userData.rib);
      formData.append("agency_id", userData.agency || "");
      formData.append("role_id", userData.role_id || "");
      if (userData.role_id == 4) {
        formData.append("can_change_statut", userData.can_change_statut ?? "0");
        formData.append("zone_id", userData.zone_liv_id || "");
        formData.append("livred_fees", userData.livred_fees || "0");
        formData.append("refused_fees", userData.refused_fees || "0");
      }
      if (updateImgInput.value?.files?.[0]) {
        formData.append("pic", updateImgInput.value.files[0]);
      }
      // attachments.value.forEach((file, index) => {
      //   formData.append(`cin_files[${index}]`, file);
      // });
      try {
        const response = await api.post(
          `/api/auth/edit_users/${props.userId}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (response.data.message === "success") {
          showToast("Utilisateur est bien modifé", "success");
        } else {
          showToast("Erreur lors de la modification de l'utilisateur", "error");
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        showToast("Erreur lors de la modification de l'utilisateur", "error");
      } finally {
        loading.value = false;
      }
    };

    const getUser = async () => {
      loading.value = true;
      try {
        const response = await api.get(
          `/api/auth/user_account/${props.userId}`
        );
        if (response && response.data) {
          Object.assign(userData, response.data);
          imagepreview.value = response.data.image || null;
          console.log(userData);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        loading.value = false;
      }

      // users fees
      try {
        const response = await api.get(`/api/auth/LivCities/${props.userId}`);
        if (response && response.data) {
          citiesDriver.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    async function getPerms() {
      try {
        const response = await api.get(
          `/api/auth/permissions_check/${props.userId}`
        );
        if (response && response.data) {
          permissionsData.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    }

    async function editFeesDriver() {
      try {
        let data = new FormData();
        data.append("citiesLiv", JSON.stringify(citiesDriver));

        const res = await api.post(
          `/api/auth/edit_cities_liv/${props.userId}`,
          data
        );

        if (res.data.message === "success") {
          showToast("Frais modifiés avec succès", "success");
          getUser();

          // Redirection si besoin
          // $router.push("/users");
        } else {
          showToast("Erreur lors de la modification des frais", "error");
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        showToast("Erreur lors de la modification des frais", "error");
      }
    }

    async function handelAffectFees() {
      try {
        let data = new FormData();
        data.append("idUser", props.userId);
        loadFees.value = true;
        const res = await api.post(`/api/auth/affecteFees`, data);

        if (res.data.success) {
          showToast("Frais sont affectés avec succès", "success");
          getUser();
          // Redirection si besoin
          // $router.push("/users");
        } else {
          showToast("Erreur lors de la modification des frais", "error");
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        showToast("Erreur lors de la modification des frais", "error");
      } finally {
        loadFees.value = false;
      }
    }

    // AddPerms method to handle permission saving
    async function AddPerms() {
      try {
        load.value = true;

        const data = new FormData();
        data.append("perms", JSON.stringify(permissionsData.value));
        data.append("user_ID", props.userId);

        const res = await api.post(`/api/auth/Add_perms_user`, data);

        if (res.data === "success") {
          showToast("Permissions mises à jour avec succès ✅", "success");
          getPerms();
        } else if (res.data === "No user") {
          showToast("Utilisateur non trouvé ❌", "error");
        } else if (res.data === "No perms") {
          showToast("Aucune permission sélectionnée ⚠️", "error");
        } else {
          showToast("Erreur inattendue, réessayez plus tard", "error");
        }
      } catch (error) {
        console.error("AddPerms error:", error);
        showToast("Erreur serveur, réessayez plus tard", "error");
      } finally {
        load.value = false;
      }
    }

    function toggleGroup(index: number) {
      permissionsData.value[index].open = !permissionsData.value[index].open;
    }

    function togglePermission(group: any, key: string) {
      const idx = group.enabled.indexOf(key);

      if (idx > -1) {
        // remove permission
        group.enabled.splice(idx, 1);
      } else {
        // add permission
        group.enabled.push(key);
      }

      // update main switch (if all enabled → true, else false)
      group.check = group.enabled.length === group.permissions.length;
    }

    function toggleAll(group: any) {
      if (group.check) {
        // select all permissions
        group.enabled = group.permissions.map((p: any) => p.key);
      } else {
        // deselect all permissions
        group.enabled = [];
      }

      // also update each perm.check for UI consistency
      group.permissions.forEach((p: any) => {
        p.check = group.check;
      });
    }
    return {
      props,
      updateImgInput,
      imagepreview,
      attachments,
      urls,
      userData,
      citiesList,
      bankList,
      agencyList,
      functionsList,
      zoneList,
      loading,
      logoSelected,
      cancelImage,
      fileSelected,
      removeFiles,
      handleSubmit,
      getUser,
      citiesDriver,
      editFeesDriver,
      loadFees,
      load,
      auth,
      AddPerms,
      handelAffectFees,
      permissionsData,
      toggleGroup,
      toggleAll,
      togglePermission,
    };
  },
});
</script>